import { render, staticRenderFns } from "./CustomerNotifications.vue?vue&type=template&id=5e2d75aa&scoped=true"
import script from "./CustomerNotifications.vue?vue&type=script&lang=js"
export * from "./CustomerNotifications.vue?vue&type=script&lang=js"
import style0 from "./CustomerNotifications.vue?vue&type=style&index=0&id=5e2d75aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d75aa",
  null
  
)

export default component.exports